define('components/handlers/filters_locations',[
    'jquery',
    'components/decorator'
], function ($, decorator) {

    $.extend(companyInfo.handlers, {


        /**
         * redirect the link with a locations filter
         */
        'filter-organisation-link': function (e) {
            e.preventDefault();
            var $el = $(e.target);
            var city = $el.data("link-city");
            var street = $el.data("link-street");
            var streetNumber = $el.data("link-streetnumber");
            var url = $el.data("link-url");

            var locationQuery = makeLocationQuery(city, street, streetNumber);

            window.location = url + locationQuery;
        },

    });

    /*
     * Returning location query for redirect to location filter, containing city, street, houseNumber
     * */
    function makeLocationQuery(city, street, streetNumber) {
        var streetNumberRegex = "";
        if (streetNumber) {
            streetNumberRegex = streetNumber
            .toString()
            .trim()
            .match(/^([0-9]+)/g);
        }
        var newStreetNumber = streetNumberRegex.length > 0 ? streetNumberRegex[0] : "";
        var cityQuery = city ? 'cities=' + city : "";
        var streetQuery = street ?
            city ? '&street=' + street : 'street=' + street
            : "";
        var streetNumberQuery = newStreetNumber ?
            street ? '&houseNumber=' + newStreetNumber : 'houseNumber=' + newStreetNumber
            : "";

        return '?' + cityQuery + streetQuery + streetNumberQuery;
    }

});

